module.exports = __webpack_public_path__ + "static/media/shop-03.92cd4da0.jpg";